import { Component, Input, Output, ViewChild, EventEmitter, ViewContainerRef, OnInit } from '@angular/core';
import { ICellChangedEvent } from './cellValueChanged.event';
import { IColumn } from './column.interface';

@Component( {
    selector: 'app-text',
    templateUrl: 'textEditor.component.html',
    styleUrls: ['textEditor.component.css']
})

export class TextEditorComponent implements OnInit {

    @Input() row: any;
    @Input() col: IColumn;
    @Input() txt: string;
    @Output() txtChanged = new EventEmitter<ICellChangedEvent>();
    @ViewChild( 'input', { read: ViewContainerRef }) private input;

    callback: Function;
    lostFocus = false;

    takeFocus( callback?: Function ) {
        setTimeout( _ =>
        {
            this.input.element.nativeElement.focus();
            this.input.element.nativeElement.select();
            this.lostFocus = false;
        });
        if (callback) {
            this.callback = callback;
        }
    }

    onChanged( e )
    {
        if (this.lostFocus) {
            return;
        }
        
        this.txtChanged.emit({
                row: this.row,
                col: this.col,
                oldValue: null,
                newValue: this.txt,
                cancel: null
            } );
    }    
    
    onKeyDown( event: KeyboardEvent ): void {

        if (event.key == 'Enter') {
            // then we may not be able to move off the cell, but still want to let other know that the val has changed
            this.lostFocus = true;
            this.txtChanged.emit({
                row: this.row,
                col: this.col,
                oldValue: null,
                newValue: this.txt,
                cancel: null
            } );
        }
    }

    ngOnInit(): void {
        this.takeFocus();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/Grid/textEditor.component.ts